const HYDRATE_EVENT = 'NOTIFY_ME_SLIDEOUT_HYDRATE'

class NotifyMeSlideout extends HHBaseElement {
  constructor() {
    super()

    this.productForm = this.querySelector('#slideout-notify-me-form')
    this.emailInput = this.querySelector('#slideout-notify-me-email')
    this.skuInput = this.querySelector('#slideout-notify-me-sku')
    this.productIdInput = this.querySelector('#slideout-notify-me-product-id')
    this.variantIdInput = this.querySelector('#slideout-notify-me-variant-id')
    this.newsletterInput = this.querySelector('#slideout-notify-me-nesletter')
    this.atcButton = this.querySelector('.js-slideout-notify-me-atc')
    this.featuredImage = this.querySelector('.js-slideout-notify-me-image')
    this.productTitle = document.querySelector('.js-slideout-notify-me-title')
    this.sendNotifyMeRequest = this.sendNotifyMeRequest.bind(this)
    this.hydrateSlideoutContent = this.hydrateSlideoutContent.bind(this)
  }

  connectedCallback() {
    this.productForm.addEventListener(
      'submit',
      this.sendNotifyMeRequest.bind(this)
    )
    this.addEventListener(HYDRATE_EVENT, this.hydrateSlideoutContent)
    this.setAttribute('initialized', '')
  }

  disconnectedCallback() {
    this.productForm.removeEventListener('submit', this.sendNotifyMeRequest)
    this.removeEventListener(HYDRATE_EVENT, this.hydrateSlideoutContent)
  }

  hydrateSlideoutContent(e) {
    const { variantId, variantSku, productId, productTitle, featuredImage } =
      e.detail

    if (variantId && this.variantIdInput) {
      this.variantIdInput.value = variantId
    }
    if (variantSku && this.skuInput) {
      this.skuInput.value = variantSku
    }
    if (productId && this.productIdInput) {
      this.productIdInput.value = productId
    }
    if (productTitle && this.productTitle) {
      this.productTitle.innerHTML = productTitle
    }
    if (featuredImage && this.featuredImage) {
      this.featuredImage.innerHTML = `<img src="${featuredImage}" alt="${productTitle}" />`
    }
  }

  async sendNotifyMeRequest(e) {
    e.preventDefault()
    const triggerButton = this.atcButton

    try {
      if (triggerButton) {
        triggerButton.setAttribute('loading', true)
      }

      const email = this.emailInput.value
      const variantId = this.variantIdInput.value

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      }

      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.klaviyoCompanyId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-06-15',
          },
          body: JSON.stringify(payload),
        }
      )

      if (!response.ok) {
        throw new Error(`Klaviyo BIS request failed: ${response.status}`)
      }

      if (this.newsletterInput.checked) {
        window._klOnsite = window._klOnsite || []
        window._klOnsite.push(['identify', { email: email }])
      }

      this.closest('slide-panel')
        ._shadowRoot.querySelector('.slide-panel__backdrop')
        .click()
    } catch (error) {
      console.error(error)
    } finally {
      if (triggerButton) {
        triggerButton.removeAttribute('loading')
      }
    }
  }
}

window.customElements.define('notify-me-slideout', NotifyMeSlideout)
